export default {
  INSERT_INTO_ALL: "INSERT_INTO_ALL_INVOICES_DEBTINVOICE",
  ADD_TO_IN_PROGRESS: "ADD_TO_IN_PROGRESS_INVOICES_DEBTINVOICE",
  REMOVE_FROM_IN_PROGRESS: "REMOVE_FROM_IN_PROGRESS_INVOICES_DEBTINVOICE",
  INSERT_INTO_FORMS: "INSERT_INTO_FORMS_INVOICES_DEBTINVOICE",
  DESTROY_FORM: "DESTROY_FORM_INVOICES_DEBTINVOICE",
  SET_FORM_ERROR: "SET_FORM_ERROR_INVOICES_DEBTINVOICE",
  UPDATE_FORM_INSTANCE: "UPDATE_FORM_INSTANCE_INVOICES_DEBTINVOICE",
  INSERT_INTO_PAGINATION: "INSERT_INTO_PAGINATION_INVOICES_DEBTINVOICE",
  INSERT_INTO_FILTERED: "INSERT_INTO_FILTERED_INVOICES_DEBTINVOICE",
  RESET_STATE: "RESET_STATE_INVOICES_DEBTINVOICE",
  SET_ASK_DELETE_DATA: "SET_ASK_DELETE_DATA_INVOICES_DEBTINVOICE",
  REMOVE_OBJECT: "REMOVE_OBJECT_INVOICES_DEBTINVOICE",
  CLEAR_FETCHED: "CLEAR_FETCHED_INVOICES_DEBTINVOICE",

  LIST_URL: "/accounting/invoices/debtinvoice/list/",
  POST_URL: "/accounting/invoices/debtinvoice/",
  PATCH_URL: "/accounting/invoices/debtinvoice/",
  GET_URL: "/accounting/invoices/debtinvoice/",

  STORE_NAME: "debtInvoice",
};
